import React from 'react';

/**
 * Sidebar Menus
 * - Logic, IDs, URLs, permissions, icons, and statuses are unchanged.
 * - Only the ordering and section grouping comments are improved for clarity.
 */

const sidebarMenusData = [
  // ======================
  // CORE OPERATIONS
  // ======================
  {
    id: '1',
    text: 'Dashboard',
    url: 'dashboard',
    icon: 'lab lab-dashboard',
    priority: 100,
    permission_name: 'view_dashboard',
    status: 1,
    children: [],
  },
  {
    id: '5',
    text: 'Pos & Orders',
    url: '#',
    icon: 'lab lab-pos',
    priority: 100,
    permission_name: 'view_pos',
    status: 1,
    children: [
      {
        id: '5.1',
        text: 'POS',
        url: 'pos',
        icon: 'lab lab-pos',
        priority: 100,
        permission_name: 'view_pos',
        status: 1,
      },
      {
        id: '5.2',
        text: 'POS Orders',
        url: 'pos-orders',
        icon: 'lab lab-pos-orders',
        priority: 100,
        permission_name: 'view_pos_orders',
        status: 1,
      },
      {
        id: '5.3',
        text: 'Table Orders',
        url: 'table-orders',
        icon: 'lab lab-reserve-line',
        priority: 100,
        permission_name: 'view_table_orders',
        status: 1,
      },
    ],
  },
  {
    id: '13',
    text: 'Waiter Board',
    url: 'waiter-board',
    icon: 'fa-solid fa-concierge-bell',
    priority: 100,
    permission_name: 'view_waiter_board',
    status: 1,
  },
  {
    id: '12',
    text: 'Kitchen',
    url: '#',
    icon: 'fa-solid fa-utensils',
    priority: 100,
    permission_name: 'view_kitchen_board',
    status: 1,
    children: [
      {
        id: '12.1',
        text: 'Board',
        url: 'kitchen',
        icon: 'fa-solid fa-utensils', // optional, but consistent
        priority: 100,
        permission_name: 'view_kitchen_board',
        status: 1,
      },
      {
        id: '12.2',
        text: 'Screen',
        url: 'kitchen-screen',
        icon: 'fa-solid fa-tv',
        priority: 100,
        permission_name: 'view_kitchen_screen',
        status: 1,
      },
    ],
  },

  // ======================
  // INVENTORY & ITEMS
  // ======================
  {
    id: '2',
    text: 'Inventory',
    url: 'inventory',
    icon: 'fa-solid fa-store',
    priority: 100,
    permission_name: 'view_inventory',
    status: 1,
    children: [],
  },
  {
    id: '3',
    text: 'Items',
    url: 'items',
    icon: 'lab lab-items',
    priority: 100,
    permission_name: 'view_items',
    status: 1,
    children: [],
  },

  // ======================
  // TABLES
  // ======================
  {
    id: '4',
    text: 'Dining Tables',
    url: 'dining-tables',
    icon: 'lab lab-dining-table',
    priority: 100,
    permission_name: 'view_dining_tables',
    status: 1,
    children: [],
  },

  // ======================
  // CUSTOMERS & ACCOUNTS
  // ======================
  {
    id: '8',
    text: 'Customer',
    url: '#',
    icon: 'lab lab-customers',
    priority: 100,
    permission_name: 'view_customers',
    status: 1,
    children: [
      {
        id: '8.1',
        text: 'Customers',
        url: 'customers',
        icon: 'lab lab-customers',
        priority: 100,
        permission_name: 'view_customers',
        status: 1,
      },
    ],
  },
  {
    id: '9',
    text: 'Accounts',
    url: '#',
    icon: 'lab',
    priority: 100,
    permission_name: 'view_transactions',
    status: 1,
    children: [
      {
        id: '9.1',
        text: 'Transactions',
        url: 'transactions',
        icon: 'lab lab-transactions',
        priority: 100,
        permission_name: 'view_transactions',
        status: 1,
      },
    ],
  },

  // ======================
  // HRM
  // ======================
  {
    id: '7',
    text: 'HRM',
    url: '#',
    icon: 'lab',
    priority: 100,
    permission_name: '',
    status: 1,
    children: [
      {
        id: '7.1',
        text: 'Administrators',
        url: 'administrators',
        icon: 'lab lab-administrators',
        priority: 100,
        permission_name: 'view_admin', // ← updated
        status: 1,
      },
      {
        id: '7.2',
        text: 'Employees',
        url: 'employees',
        icon: 'lab lab-employee',
        priority: 100,
        permission_name: 'view_employees',
        status: 1,
      },
      // Attendance
      {
        id: '7.3',
        text: 'Attendance',
        url: 'attendance',
        icon: 'lab lab-employee',
        priority: 100,
        permission_name: 'view_attendance',
        status: 1,
      },
      // Leave Requests
      {
        id: '7.4',
        text: 'Leave Requests',
        url: 'leave-requests',
        icon: 'lab lab-employee',
        priority: 100,
        permission_name: 'view_leave',
        status: 1,
      },
      {
        id: '7.5',
        text: 'Chef',
        url: 'chefs',
        icon: 'fa-solid fa-kitchen-set',
        priority: 100,
        permission_name: 'view_chefs',
        status: 1,
      },
      {
        id: '7.6',
        text: 'Waiter',
        url: 'waiters',
        icon: 'lab lab-pos',
        priority: 100,
        permission_name: 'view_waiters',
        status: 1,
      },
    ],
  },

  // ======================
  // PROMO / MARKETING
  // ======================
  {
    id: '6',
    text: 'Promo',
    url: '#',
    icon: 'lab',
    priority: 100,
    permission_name: 'view_offers',
    status: 1,
    children: [
      {
        id: '6.1',
        text: 'Offers',
        url: 'offers',
        icon: 'lab lab-offers',
        priority: 100,
        permission_name: 'view_offers',
        status: 1,
      },
    ],
  },

  // ======================
  // REPORTS
  // ======================
  {
    id: '10',
    text: 'Reports',
    url: '#',
    icon: 'lab',
    priority: 100,
    permission_name: '',
    status: 1,
    children: [
      {
        id: '10.1',
        text: 'Sales Report',
        url: 'sales-report',
        icon: 'lab lab-sales-report',
        priority: 100,
        permission_name: 'view_sales_report',
        status: 1,
      },
      {
        id: '10.2',
        text: 'Items Report',
        url: 'items-report',
        icon: 'lab lab-items-report',
        priority: 100,
        permission_name: 'view_items_report',
        status: 1,
      },
      {
        id: '10.3',
        text: 'Credit Balance Report',
        url: 'credit-balance-report',
        icon: 'lab lab-credit-balance-report',
        priority: 100,
        permission_name: 'view_credit_balance_report',
        status: 1,
      },
    ],
  },

  // ======================
  // SETUP
  // ======================
  {
    id: '11',
    text: 'Setup',
    url: '#',
    icon: 'lab',
    priority: 100,
    permission_name: 'view_setting', // ← updated
    status: 1,
    children: [
      {
        id: '11.1',
        text: 'Settings',
        url: 'settings/company',
        icon: 'lab lab-settings',
        priority: 100,
        permission_name: 'view_setting', // ← updated
        status: 1,
        children: [
          {
            id: '11.1.1',
            text: 'Company',
            url: 'settings/company',
            icon: 'lab lab-company',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.2',
            text: 'Site',
            url: 'settings/site',
            icon: 'lab lab-site',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.3',
            text: 'Branches',
            url: 'settings/branches',
            icon: 'lab lab-branches',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.4',
            text: 'Mail',
            url: 'settings/mail',
            icon: 'lab lab-mail',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.5',
            text: 'Otp',
            url: 'settings/otp',
            icon: 'lab lab-otp',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.6',
            text: 'Notification',
            url: 'settings/notification',
            icon: 'lab lab-notification',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.7',
            text: 'Notification Alert',
            url: 'settings/notification-alert',
            icon: 'lab lab-license',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.8',
            text: 'Analytics',
            url: 'settings/analytics',
            icon: 'lab lab-analytics',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.9',
            text: 'Theme',
            url: 'settings/theme',
            icon: 'lab lab-theme',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.10',
            text: 'Currencies',
            url: 'settings/currencies',
            icon: 'lab lab-currencies',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.11',
            text: 'Item Categories',
            url: 'settings/item-categories',
            icon: 'lab lab-item-categories',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.12',
            text: 'Item Attributes',
            url: 'settings/item-attributes',
            icon: 'lab lab-item-attributes',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.13',
            text: 'Taxes',
            url: 'settings/taxes',
            icon: 'lab lab-taxes',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.14',
            text: 'Pages',
            url: 'settings/pages',
            icon: 'lab lab-pages',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.15',
            text: 'Role Permissions',
            url: 'settings/role',
            icon: 'lab lab-role-permissions',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.16',
            text: 'Languages',
            url: 'settings/language',
            icon: 'lab lab-languages',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.17',
            text: 'SMS Gateway',
            url: 'settings/sms-gateway',
            icon: 'lab lab-sms',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.18',
            text: 'Payment Gateway',
            url: 'settings/payment-gateway',
            icon: 'lab lab-payment-gateway',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
          {
            id: '11.1.19',
            text: 'License',
            url: 'settings/license',
            icon: 'lab lab-license',
            priority: 100,
            permission_name: 'update_setting', // ← updated
            status: 1,
          },
        ],
      },
    ],
  },
];

export default sidebarMenusData;
